import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { analyticsApi } from "@/lib/newsApi";

const VISITOR_KEY = "px_visitor_id";

function getVisitorId() {
  let id = localStorage.getItem(VISITOR_KEY);
  if (!id) {
    id = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`);
    localStorage.setItem(VISITOR_KEY, id);
  }
  return id;
}

/**
 * First-party visitor tracking. Fires a lightweight beacon on every public
 * route change (the CRM area under /crm and /$$login is never tracked).
 */
export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname || "/";
    if (path.startsWith("/crm") || path.startsWith("/$$login")) return;
    analyticsApi.track(getVisitorId(), path).catch(() => {});
  }, [location.pathname]);

  return null;
}
